<ion-accordion-group class="one3d-accordion-sub-wrapper">
  <ion-accordion
    toggleIcon="add"
    *ngFor="let features of features"
    [value]="features.featureCategory"
    (click)="openFeatureList(features.category_id)"
    (keypress)="openFeatureList(features.category_id)"
  >
    <ion-item class="one3d-accordion-sub-item" slot="header">
      <ion-label class="one3d-accordion-sub-label">{{
        features.featureCategory | uppercase | translate
      }}</ion-label>
      <span class="ion-accordion-toggle-icon"></span>
    </ion-item>
    <ion-list slot="content" class="ion-no-padding">
      <ion-item
        *ngFor="let feature of features.featureList"
        detail="false"
        (click)="playFeatures(feature, features.featureCategory)"
        (keypress)="playFeatures(feature, features.featureCategory)"
        class="one3d-accordion-sub-list-item"
      >
        <ion-text class="one3d-accordion-sub-list">
          {{ feature.feature_name }}
        </ion-text>
      </ion-item>
    </ion-list>
  </ion-accordion>
</ion-accordion-group>
